<template>
  <div>
    <h1>This is an Home page</h1>
  </div>
</template>
